import { render, staticRenderFns } from "./ai_statement.vue?vue&type=template&id=542f7c94&scoped=true"
import script from "./ai_statement.vue?vue&type=script&lang=js"
export * from "./ai_statement.vue?vue&type=script&lang=js"
import style0 from "./ai_statement.vue?vue&type=style&index=0&id=542f7c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f7c94",
  null
  
)

export default component.exports